export default {
  items: [
    {
      name: "Inicio",
      url: "/dashboard",
      icon: "fa fa-area-chart"
    },
    {
      divider: true
    },
    {
      name: "Operaciones",
      url: "",
      icon: "fa fa-tasks",
      children: [
        {
          name: "Comprobante Diario",
          url: "/comprobantes-diario",
          icon: "icon-note"
        },
        {
          name: "CKs - Transferencias",
          url: "/cheques-transferencias",
          icon: "icon-wallet"
        },
        {
          name: "Comprobantes Automáticos",
          url: "/comprobantes-automaticos",
          icon: "fa fa-microchip"
        },
        {
          name: "Cierre Mensual",
          url: "/cierre-mensual",
          icon: "fa fa-book"
        },
        {
          name: "Conciliacion Bancaria",
          url: "/conciliacion",
          icon: "fa fa-check"
        }
      ]
    },
    {
      divider: true
    },
   /* {
      name: "Catalogos",
      url: "",
      icon: "icon-list",
      children: [

        {
          name: "Catalogos de Cuentas",
          url: "/catalogos",
          icon: "icon-notebook"
        },
        {
          name: "Empresas",
          url: "/empresas",
          icon: "fa fa-list"
        },
        {
          name: "Centros",
          url: "/centros",
          icon: "fa fa-list"
        },
        {
          name: "Tipo Cambio",
          url: "/tipo-cambio",
          icon: "fa fa-money"
        },
        {
          name: "Cuentas para Cheques",
          url: "/cuentas-cks",
          icon: "fa fa-list"
        }
      ]
    }, */
    {
      divider: true
    },
    {
      name: "Reportes",
      url: "/reportes",
      icon: "fa fa-file",
      children: [
        {
          name: "Libro Diario",
          url: "/reportes/diario",
          icon: "fa fa-calendar"
        },
        {
          name: "Auxiliar por Cuenta",
          url: "/reportes/aux-diario",
          icon: "fa fa-file-archive-o"
        },
        {
          name: "Libro Mayor",
          url: "/reportes/mayor",
          icon: "fa fa-calendar-o"
        },
        {
          name: "Balanza Comprobación",
          url: "/reportes/bcomprobacion",
          icon: "fa fa-check-square-o"
        },
        {
          name:"Estados Financieros",
          url: "/reportes/estados-financieros",
          icon: "fa fa-book"
        },
        {
          name:"EEFF Acumulado Mensual",
          url: "/reportes/estados-financieros-mensuales",
          icon: "fa fa-book"
        },
        {
          name: "Tipo Cambio",
          url: "/tipo-cambio",
          icon: "fa fa-money"
        },
      ]
    },
    {
      divider: true
    },
    {
      name: "Configuraciones",
      url: "/users",
      icon: "icon-wrench",
      open:true,
      children: [
          {
            name: "Catalogos de Cuentas",
            url: "/catalogos",
            icon: "icon-notebook"
          },
          {
            name: "Empresas",
            url: "/empresas",
            icon: "fa fa-list"
          },
          {
            name: "Centros",
            url: "/centros",
            icon: "fa fa-list"
          },
          {
            name: "Cuentas para Cheques",
            url: "/cuentas-cks",
            icon: "fa fa-list"
          },
        {
          name: "Usuarios",
          url: "/users",
          icon: "fa fa-users"
        },
        /*{
          name: "Diseñar Reportes",
          url: "/config/reportes-create",
          icon: "fa fa-file"
        }*/
      ]
    }
  ]
};
